import Typography from 'common/design-system/components-v2/Typography';

export const getConfigurationDrawerHeader = () => (
    <div>
        <Typography variant='h2'>Integrations</Typography>
        <Typography variant='bodyLg'>Configure integration for easy reuse</Typography>
    </div>
);
